import { render, staticRenderFns } from "./ReservationEvent.vue?vue&type=template&id=66c0098e"
import script from "./ReservationEvent.vue?vue&type=script&lang=js"
export * from "./ReservationEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports